import React from 'react';
import { FaClock } from 'react-icons/fa';
import styled from 'styled-components';
import { Button } from '../../../button';
import { Modal } from '../../../layout/modal';
import { ModalContent, ModalTitle } from '../../../layout/modal/content';
import { CardDetails, CardDetailsLeft, CardHeader, CardHeaderRight, HeaderRightItem, mapToServiceName, ServiceStyle, } from '../../card';
import { OrderIcon } from '../../card/card-icon';
import { CommonText } from '../../commonText';
import { DeliveryProvider } from '../../deliveryProvider';
const getOrderItemBg = (type) => {
    switch (type) {
        case 'Unconfirmed':
            return '#e5ac00';
        case 'Confirmed':
            return '#A5C100';
        case 'Ready':
            return '#0064C8';
        case 'On-route':
            return '#00A6DD';
        case 'Completed':
            return '#009100';
        case 'Cancelled':
            return '#BC362F';
        default:
            return '#e5ac00';
    }
};
export const OrderStatusWrapper = styled.div `
  padding: 16px;
  display: grid;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(202px, 1fr));
  grid-gap: 15px;
  padding: 17px 0;
`;
export const OrderStatusItem = styled.div `
  padding: 8px 16px 8px 16px;
  background: ${({ type }) => getOrderItemBg(type)};
  width: 100%;
  // height: ${({ height }) => height ? height : "40px"};
  border-radius: 4px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;
export const OrderQuantity = styled.div `
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(12, 32, 42, 0.2);
  div {
    position: relative;
    display: inline-block;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
const getOrderStatusItemTitle = (order, item) => {
    if (order && order.status && item && item.type === order.status) {
        return `${item.text} (Current Status)`;
    }
    return item.text;
};
export const ChangeStatusModal = ({ selectedItemIds, order, changeStatusActive, setChangeStatusActive, handleChangeStatus, orderStatusData, }) => {
    const changeStatus = (type) => {
        if (type !== 'confirmed') {
            handleChangeStatus(order, type);
        }
    };
    return (React.createElement(Modal, { active: changeStatusActive, width: 542, close: () => setChangeStatusActive(false) },
        React.createElement(ModalTitle, { className: "round-top text-center" },
            React.createElement("h3", null, "Change Order Status")),
        React.createElement(CardHeader, null,
            React.createElement(ServiceStyle, { service: order.config.service }, mapToServiceName(order.config.service)),
            React.createElement(CardHeaderRight, null,
                order.config.service === 'dine_in' && React.createElement("div", null, order.config.table),
                order.config.service === 'delivery' && order.ready_in && order.ready_in.timestamp && (React.createElement(React.Fragment, null,
                    React.createElement(FaClock, null),
                    React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" },
                        new Date(order.ready_in.timestamp - Date.now()).getMinutes(),
                        " Mins"))),
                React.createElement(HeaderRightItem, null))),
        React.createElement(CardDetails, { allSelected: selectedItemIds.length === order.dishes.length },
            React.createElement(CardDetailsLeft, null,
                React.createElement(DeliveryProvider, { provider: order.config.delivery_provider }),
                React.createElement(OrderIcon, null),
                React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" }, order.number)),
            React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#4B4F5E" },
                selectedItemIds.length,
                " / ",
                order.dishes.length,
                " Items")),
        React.createElement(ModalContent, { style: { minHeight: '283px' } },
            React.createElement(OrderStatusWrapper, null, orderStatusData.map(item => (React.createElement(OrderStatusItem, { key: item.id, type: item.text, onClick: () => changeStatus(item.type) },
                React.createElement("div", null, getOrderStatusItemTitle(order, item)))))),
            React.createElement("div", null,
                React.createElement(Button, { type: "button", full: true, className: "m-r-2", onClick: () => setChangeStatusActive(false) }, "Cancel")))));
};
//# sourceMappingURL=index.js.map